module.exports = __webpack_public_path__ + "img/motti-pro.1fe0f493.jpg";